import React from 'react';
import styled from 'styled-components';

import { Brand, MicrodataHTMLAttributes, schema } from '@rover/components/src/microdata';
import { Heading } from '@rover/kibble/core';
import MediaQuery from '@rover/kibble/styles/MediaQuery';
import type { LinkedLocation } from '@rover/types/src/apiResponses/FetchSeoLocationResponse';

type Props = {
  seoLocations: LinkedLocation[];
  titleHeader: string;
  serviceTypeName?: string;
  indexUrl?: string;
  seeMoreUrl?: string;
  seeMoreName?: string;
  listItemProps?: MicrodataHTMLAttributes;
};

const StyledList = styled.ul`
  list-style-type: none;
  padding: 0px;
  margin-top: 0;
  display: grid;
  max-width: 1024px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 8px;

  li {
    margin-bottom: 4px;
  }

  ${MediaQuery.SM.toString()} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${MediaQuery.MD_UP.toString()} {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const SeoLocationList: React.FC<Props & MicrodataHTMLAttributes> = ({
  titleHeader,
  seoLocations,
  seeMoreUrl,
  seeMoreName,
  serviceTypeName = '',
  indexUrl,
  ...props
}) => {
  if (!seoLocations || !seoLocations.length) return null;

  return (
    <>
      <Heading marginTop="8x" size="400">
        {titleHeader}
      </Heading>
      <StyledList>
        {seoLocations.map((link) => {
          return (
            <li key={link.locationName} {...props} itemScope itemType={schema`Service`}>
              <Brand itemProp="brand" indexUrl={indexUrl} />
              <a href={link.absoluteUrl} itemProp="url">
                {serviceTypeName && <meta itemProp="category" content={serviceTypeName} />}
                <meta
                  itemProp="serviceType"
                  content={`${serviceTypeName} ${link.locationName}`.trim()}
                />
                {link.locationName}
              </a>
            </li>
          );
        })}
        {seeMoreUrl && seeMoreName && (
          <li>
            <a href={seeMoreUrl}>{seeMoreName}</a>
          </li>
        )}
      </StyledList>
    </>
  );
};

export default SeoLocationList;
